class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
    this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
    this.current = 0;

    const prevButton = this.querySelector('[data-slide-prev]');
    const nextButton = this.querySelector('[data-slide-next]');

    if (prevButton) prevButton.addEventListener('click', () => this.go(this.current - 1));
    if (nextButton) nextButton.addEventListener('click', () => this.go(this.current + 1));

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.go(index));
    });
  }

  go(index) {
    const total = this.slides.length;
    if (total === 0) return;

    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
}

document.addEventListener('click', (event) => {
  const decreaseButton = event.target.closest('[data-quantity-decrease]');
  const increaseButton = event.target.closest('[data-quantity-increase]');
  if (!decreaseButton && !increaseButton) return;

  const wrapper = (decreaseButton || increaseButton).closest('.product-page__quantity');
  const input = wrapper.querySelector('input[type="number"]');
  const currentValue = parseInt(input.value, 10) || 1;
  const min = parseInt(input.min, 10) || 1;

  if (decreaseButton) {
    input.value = Math.max(min, currentValue - 1);
  } else {
    input.value = currentValue + 1;
  }

  input.dispatchEvent(new Event('change', { bubbles: true }));
});
